import Image from 'next/image'

import { cn } from '@/utilities/ui'
import { ACADEMY_ILLUSTRATIONS } from '@/utilities/academyIllustrations'

interface Props {
  /** Per-course illustration slug (see `ACADEMY_ILLUSTRATIONS`). */
  illustration?: string | null
  className?: string
  /** Override the illustration's default alt text. */
  alt?: string
  /** Load eagerly (above-the-fold use, e.g. course hero). Defaults to lazy. */
  priority?: boolean
}

/**
 * Renders the course's chosen illustration. Returns nothing when no illustration
 * is set, so the slot stays blank rather than showing a generic placeholder.
 * `object-contain` keeps any aspect ratio inside its container box.
 */
export function AcademyCourseIllustration({ illustration, className, alt, priority }: Props) {
  const resolved = illustration ? ACADEMY_ILLUSTRATIONS[illustration] : undefined
  if (!resolved) return null

  return (
    <Image
      src={resolved.src}
      alt={alt ?? resolved.alt}
      width={resolved.width}
      height={resolved.height}
      priority={priority}
      unoptimized
      className={cn('block', className)}
    />
  )
}
